import img1 from './assets/image-1.webp';
import img2 from './assets/image-2.webp';
import img3 from './assets/image-3.webp';
import img4 from './assets/image-4.webp';
import img5 from './assets/image-5.webp';
import img6 from './assets/image-6.webp';
import img7 from './assets/image-7.webp';
import img8 from './assets/image-8.webp';

export const featuresContent = {
    titleTop: 'парадная вместо подъезда:<br> <span>эстетика и комфорт <br>с первого шага</span>',
    textTop: 'мы убрали барьеры и добавили<br> света. использовали теплые тона <span>и<br> много стекла, чтобы вы чувствовали<br> себя дома, едва войдя в подъезд</span>',
    titleBottom: 'парковка, за которую<br> <span>не нужно платить</span>',
    textBottom: 'мы вынесли машины за периметр<br> двора, обеспечив коэффициент <br><span> 0,7 (7 мест на 10 квартир) и полную<br> безопасность детей</span>',

    featuresTopBlock: [
        {
            image: img1,
            itemTitle: 'вход с уровня земли',
            itemText: 'вы заходите в подъезд<br>  свободно с коляской,<br> <span>велосипедом или тяжелыми<br> сумками</span>'
        },
        {
            image: img2,
            itemTitle: 'прозрачные двери',
            itemText: 'витражное остекление входных <br> групп дает <span>много естественного <br> света и чувство безопасности</span>'
        },
        {
            image: img3,
            itemTitle: 'быстрые и тихие лифты',
            itemText: 'лифтовые шахты не граничат <br>  жилыми комнатами,<br> <span>сохраняя тишину в квартирах</span>'
        },
        {
            image: img4,
            itemTitle: 'колясочные и хранение',
            itemText: 'в каждом подъезде есть<br> закрытые комнаты для <span>хранения<br> колясок, самокатов <br> и велосипедов</span>'
        },
    ],

    featuresBottomBlock: [
        {
            image: img5,
            itemTitle: 'бесплатные<br> машино-места',
            itemText: 'вы сохраняете около 1,7 млн<br> рублей (средняя стоимость паркинга <span>в Перми), получая гарантированное<br>  место для авто бесплатно</span>'
        },
        {
            image: img6,
            itemTitle: 'гостевые места',
            itemText: 'предусмотрены места<br> для гостей <span>с внешней<br> стороны улиц</span>'
        },
        {
            image: img7,
            itemTitle: 'зарядка электромобилей',
            itemText: 'на территории предусмотрены <br> специализированные <span>посты <br> для  зарядки электромобилей</span>'
        },
        {
            image: img8,
            itemTitle: 'видеонаблюдение 24/7',
            itemText: 'камеры охватывают внешний <br>  периметр парковки. <span>доступ к <br>  камерам через смартфон 24/7</span>'
        },
    ]
}